import { useState } from 'react';
import { GOAL_TYPE, MILESTONE_TYPE } from './components/layouts/route';

/**
 * Edistyminen — the map as a progress view: the towns (scenario roots), their
 * milestones and goals, nothing else; the mission card is added on top as
 * always (withRootNode). A kept card whose parent is hidden hangs from its
 * nearest kept ancestor, so the tree stays whole. Cross-links, blockers and
 * loops are off in this view (ImpactMapView).
 */
const isProgressNode = (n) => Boolean(n.is_scenario_starter) || n.type === 'scenario_root'
  || n.type === GOAL_TYPE || n.type === MILESTONE_TYPE;

const parentOf = (n) => n.parentId || n.parent_id || null;

export function progressOnly(pathways = []) {
  const byId = new Map(pathways.map((n) => [n.id, n]));
  const kept = pathways.filter(isProgressNode);
  const keptIds = new Set(kept.map((n) => n.id));
  return kept.map((n) => {
    const seen = new Set([n.id]);
    let p = parentOf(n);
    while (p && !keptIds.has(p) && !seen.has(p)) { seen.add(p); p = byId.get(p) ? parentOf(byId.get(p)) : null; }
    const parent = p && keptIds.has(p) ? p : null;
    return parent === parentOf(n) ? n : { ...n, parentId: parent, parent_id: parent };
  });
}

const STORE = (instanceKey) => `kuutio-impactmap-progress:${instanceKey}`;

/** The toggle, remembered per instance in this browser (a viewer's convenience). */
export function useProgressView(instanceKey) {
  const [on, setOn] = useState(() => {
    try { return localStorage.getItem(STORE(instanceKey)) === 'on'; } catch { return false; }
  });
  const toggle = () => {
    const next = !on;
    try { localStorage.setItem(STORE(instanceKey), next ? 'on' : 'off'); } catch { /* the view still switches */ }
    setOn(next);
  };
  return [on, toggle];
}
